import { useCustomCreateDailyFormVehicleServicePlanMutation } from "generated/graphql";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useCreateDailyFormVehicleServicePlan() {
  const [mutation, { loading, data, error }] = useCustomCreateDailyFormVehicleServicePlanMutation();

  const [createDailyFormVehicleServicePlan, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "createDailyFormVehicleServicePlan",
    },
    { hideMessage: true }
  );

  return [createDailyFormVehicleServicePlan, context] as const;
}
